<script setup lang="ts">
import { ref, watch } from "vue";
import { storeToRefs } from "pinia";
import { useRouter } from "vue-router";
import { useMemberService } from "@/stores/memberFunction/memberService";
import { onMounted } from "vue";

import activity_up from "@image/memberFunction/02/activity_up.png";
import activity_down from "@image/memberFunction/02/activity_down.png";
import btn_n from "@image/memberFunction/common/btn_n.png";
import 裝飾左 from "@image/memberFunction/02/裝飾左.png";
import 裝飾右 from "@image/memberFunction/02/裝飾右.png";

import NewsType1 from "@image/memberFunction/08/news_btn_01.png";
import NewsType2 from "@image/memberFunction/08/news_btn_02.png";
import NewsType3 from "@image/memberFunction/08/news_btn_03.png";
import NewsType4 from "@image/memberFunction/08/news_btn_04.png";

import ContentNewsWeb from "@/components/content/News/contentNewsWeb.vue";

const memberService = useMemberService();
const router = useRouter();

const { NewJumpMes } = storeToRefs(memberService);

const activeItems = ref<boolean[]>([]);
watch(NewJumpMes, () => {
  activeItems.value = NewJumpMes.value.map(() => {
    return false;
  });
});

const toggleItem = (index: any) => {
  activeItems.value[index] = !activeItems.value[index];
};

function toService() {
  router.push({ name: "Service" });
}

function NewsTypeImage(type: string) {
  let image;
  switch (type) {
    case "客服":
      image = NewsType1;
      break;
    case "活動":
      image = NewsType2;
      break;
    case "維護":
      image = NewsType3;
      break;
    case "重要":
      image = NewsType4;
      break;
    default:
      image = NewsType1;
      break;
  }
  return image;
}

onMounted(() => {
  memberService.getNewMessageData();
});
</script>

<template>
  <div class="hidden md:block">
    <ContentNewsWeb />
  </div>
  <div class="mx-5 text-[#fff] mb-5 h-[94dvh] overflow-y-auto block md:hidden gamePlatform-scrollbar">
    <ul class="relative mt-[1vh] pb-[14dvh] md:mb-0">
      <li class="mt-[3vw] first:mt-0 relative" v-for="(items, index) in NewJumpMes" :key="items.nId">
        <button class="z-10 absolute w-[98%] left-1/2 -translate-x-1/2 top-[5px]" @click="toggleItem(index)">
          <div class="rounded-[6px] relative">
            <div
              class="z-10 rounded-[8px] overflow-hidden absolute top-[calc(50%-.1vh)] -translate-y-1/2 left-1/2 -translate-x-1/2 h-[calc(100%-.4vh)] w-[calc(100%-1vw)] flex items-center justify-center">
              <div class="relative w-full h-full">
                <div class="absolute top-[10px] left-[10px] w-[60px] h-[30px] z-10">
                  <img class="relative top-[2px]" v-img-src="NewsTypeImage(items.sKindTitle0)" alt="" />
                  <p
                    class="truncate absolute top-1/2 -translate-y-1/2 w-[90%] left-1/2 -translate-x-1/2 text-black font-bold">
                    {{ items.sKindTitle0 }}
                  </p>
                </div>
                <div class="w-full h-full bg-gradient-to-br from-gray-700 to-gray-900 flex items-center justify-center">
                  <p class="text-white text-[16px] font-bold px-4 text-center">
                    {{ items.sTitle0 }}
                  </p>
                </div>
              </div>
            </div>
            <img v-img-src="activity_up" alt="" />
          </div>
        </button>

        <div class="relative">
          <img v-img-src="activity_down" alt="" />

          <div class="text-[14px] absolute flex justify-end w-full px-[12px] bottom-[5px]">
            <button type="button" class="shrink-0 relative px-[4vw] mr-[3vw]" @click="toggleItem(index)"
              v-if="!activeItems[index]">
              <img v-img-src="btn_n" alt="" class="h-full w-full absolute" />
              <p class="text-primary relative z-10 py-[.2vh] left-[4vw] tracking-[.4vw] font-bold">
                {{ $t("Context.Discount.Details") }}
              </p>
            </button>
          </div>
        </div>
        <transition name="zoom" mode="out-in">
          <div v-if="activeItems[index]" class="mt-[2vw] w-full member-bg-border">
            <div class="w-full h-full z-20 relative py-[12px]">
              <div class="flex justify-center items-center mt-[12px]">
                <img v-img-src="裝飾左" alt="" class="w-[30%]" />
                <p class="mx-[12px] text-[14px] text-yellow-400">
                  {{ $t("Context.NewsAlert.News") }}
                </p>
                <img v-img-src="裝飾右" alt="" class="w-[30%]" />
              </div>
              <div class="mt-[12px] px-[12px] text-[14px] leading-[24px]">
                <div class="news-content" v-html="items.sContent0"></div>
                <div class="mt-[12px] text-[12px] text-news-sub-title">
                  <p>{{ items.sCreateTime }}</p>
                </div>
              </div>
              <div class="text-[14px] flex justify-around my-[12px]">
                <button type="button" class="btn-y-border px-[4vw]" @click="toService()">
                  <p class="text-secondary z-10 py-[.2vh] tracking-[.4vw]">
                    {{ $t("Context.Discount.ContactService") }}
                  </p>
                </button>
                <button type="button" class="btn-n-border px-[4vw]" @click="toggleItem(index)">
                  <p class="text-primary z-10 py-[.2vh] tracking-[.4vw]">
                    {{ $t("Context.Discount.ClosePage") }}
                  </p>
                </button>
              </div>
            </div>
          </div>
        </transition>
      </li>
    </ul>
  </div>
</template>

<style scoped>
.zoom-enter-active {
  transform: scale(0);
  transition: all 0.3s ease-out;
}

.zoom-leave-active {
  transition: all 0.3s ease-in;
}

.zoom-leave-to {
  transform: scale(0);
}

.zoom-enter-to {
  transform: scale(1);
}

.news-content :deep(table) {
  width: 100%;
  margin: auto;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.news-content :deep(th),
.news-content :deep(td) {
  border: 1px solid #ddd;
  padding: 2px;
  text-align: center;
}
</style>
